var map = {
	"./symbol_0.png": 86028,
	"./symbol_1.png": 97653,
	"./symbol_2.png": 60926,
	"./symbol_3.png": 53063,
	"./symbol_4.png": 73448,
	"./symbol_5.png": 5489,
	"./symbol_6.png": 45594
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 26855;